import { CHANGE_USER_PROFILE_SUCCESS } from '../constants/user_profile.constants';
import { GET_USER_PROFILE_SUCCESS, GET_USER_PROFILE_REQUEST, GET_USER_PROFILE_FAILURE } from '../constants/get_user_profile.constants';
import {
    USER_PROFILE_GROUPS_ADD_REQUEST,
    USER_PROFILE_GROUPS_REMOVE_REQUEST,
    USER_PROFILE_GROUPS_READ_REQUEST,
    USER_PROFILE_GROUPS_READ_SUCCESS,
    USER_PROFILE_GROUPS_READ_FAILURE,
    USER_PROFILE_GROUPS_ADD_SUCCESS,
    USER_PROFILE_GROUPS_ADD_FAILURE,
    USER_PROFILE_GROUPS_REMOVE_SUCCESS,
    USER_PROFILE_GROUPS_REMOVE_FAILURE,
} from '../constants/user_profile_groups.constants';

import { GENERATE_USER_API_TOKEN, GENERATE_USER_API_TOKEN_SUCCESS, GENERATE_USER_API_TOKEN_FAILURE } from '../constants/generate_user_api_token.constants';
import { reduxSetter } from '../../../../../utils/reduxSetter';

const initialState = {
    User_profile_table: {
        loading: false,
        profile: null,
        options: null,
        field_key: null,
        error: null,
    },
    User_profile_groups: {
        loading: false,
        groups: null,
        selectedKeys: [],
        error: null,
    },
    User_profile_divisions: {
        loading: false,
        error: null,
    },
    user_api_token_loading: false,
    user_api_token: undefined,
    user_api_token_error: undefined,
};

export const User_profile = (state = initialState, action) => {
    const {
        type, prefix, item, error,
    } = action;
    switch (type) {
    case 'SET_USER_PROFILE_DATA':
        return reduxSetter(state, action);
    case GENERATE_USER_API_TOKEN:
        return {
            ...state,
            user_api_token_loading: true,
            user_api_token: undefined,
            user_api_token_error: undefined,
        };

    case GENERATE_USER_API_TOKEN_SUCCESS:
        return {
            ...state,
            user_api_token_loading: false,
            user_api_token: action.payload,
            user_api_token_error: undefined,
        };

    case GENERATE_USER_API_TOKEN_FAILURE:
        return {
            ...state,
            user_api_token_loading: false,
            user_api_token: undefined,
            user_api_token_error: action.error,
        };

    case 'RESET_USER_PROFILE':
        return {
            ...state,
            User_profile_table: {
                ...state.User_profile_table,
                profile: null,
            },
        };

    case 'USER_PROFILE_CHANGE_DATA_HANDLER':
        if (action.login) {
            return {
                ...state,
                User_profile_table: {
                    ...state.User_profile_table,
                    profile: {
                        ...state.User_profile_table.profile,
                        login: action.login || (action.login === '' && []) || state.User_profile_table.profile.login,
                    },
                },
            };
        }

        return {
            ...state,
            User_profile_table: {
                ...state.User_profile_table,
                profile: {
                    login: action.login || (action.login === '' && []) || state.User_profile_table.profile.login,
                    ...state.User_profile_table.profile,
                    person: {
                        ...state.User_profile_table.profile.person,
                        first_name: action.first_name || (action.first_name === '' && []) || state.User_profile_table.profile.person.first_name,
                        last_name: action.last_name || (action.last_name === '' && []) || state.User_profile_table.profile.person.last_name,
                        extension_number: action.extension_number || (action.extension_number === '' && []) || state.User_profile_table.profile.person.extension_number,
                    },
                },
            },
        };

    case GET_USER_PROFILE_REQUEST:
        return {
            ...state,
            User_profile_table: {
                ...state.User_profile_table,
                loading: true,
            },
        };
    case GET_USER_PROFILE_SUCCESS:
        return {
            ...state,
            User_profile_table: {
                ...state.User_profile_table,
                profile: action.profile,
                options: action.options,
                loading: false,
            },
        };

    case GET_USER_PROFILE_FAILURE:
        return {
            ...state,
            User_profile_table: {
                ...state.User_profile_table,
                loading: false,
                error,
            },
        };

    case `${prefix}_USER_${item}_REQUEST`:
        return {
            ...state,
            User_profile_table: {
                ...state.User_profile_table,
                field_key: (prefix === 'CHANGE' && item === 'USER') ? action.params.key : null,
                loading: true,
            },
        };
    case `${prefix}_USER_${item}_SUCCESS`:
        const action_key = Object.keys(action)[1];
        return {
            ...state,
            User_profile_table: {
                ...state.User_profile_table,
                loading: false,
                profile: item !== 'PROFILE' ? {
                    ...state.User_profile_table.profile,
                    person: {
                        ...state.User_profile_table.profile.person,
                        [action_key]: action[action_key],
                    },
                } : action.profile,
            },
        };
    case CHANGE_USER_PROFILE_SUCCESS:
        const { key, data } = action.profile; const
            profile_changed = data
                ? data.find(item => item._id === action.profile.profile_changed && item)
                : action.profile.profile_changed;
        return {
            ...state,
            User_profile_table: {
                ...state.User_profile_table,
                field_key: null,
                loading: false,
                profile: (key === 'login' || key === 'ref_user_group')
                    ? { ...state.User_profile_table.profile, [key]: profile_changed }
                    : { ...state.User_profile_table.profile, person: { ...state.User_profile_table.profile.person, [key]: profile_changed } },
            },
        };
    case `${prefix}_USER_${item}_FAILURE`:
        return {
            ...state,
            User_profile_table: {
                ...state.User_profile_table,
                field_key: null,
                error,
                loading: false,
            },
        };
    case USER_PROFILE_GROUPS_ADD_REQUEST:
    case USER_PROFILE_GROUPS_REMOVE_REQUEST:
    case USER_PROFILE_GROUPS_READ_REQUEST:
        return {
            ...state,
            User_profile_groups: {
                ...state.User_profile_groups,
                loading: true,
            },
        };

    case USER_PROFILE_GROUPS_READ_SUCCESS:
        return {
            ...state,
            User_profile_groups: {
                ...state.User_profile_groups,
                groups: action.payload,
                selectedKeys: [],
                loading: false,
            },
        };


    case USER_PROFILE_GROUPS_ADD_SUCCESS:
        return {
            ...state,
            User_profile_table: {
                ...state.User_profile_table,
                profile: {
                    ...state.User_profile_table.profile,
                    groups: action.payload,
                },
            },
            User_profile_groups: {
                ...state.User_profile_groups,
                loading: false,
            },
        };

    case USER_PROFILE_GROUPS_REMOVE_SUCCESS:
        return {
            ...state,
            User_profile_table: {
                ...state.User_profile_table,
                profile: {
                    ...state.User_profile_table.profile,
                    groups: action.payload,
                },
            },
            User_profile_groups: {
                ...state.User_profile_groups,
                loading: false,
            },
        };

    case 'SELECT_GROUP_KEYS':
        return {
            ...state,
            User_profile_groups: {
                ...state.User_profile_groups,
                selectedKeys: [...action.source, ...action.target],
            },
        };

    case USER_PROFILE_GROUPS_READ_FAILURE:
    case USER_PROFILE_GROUPS_ADD_FAILURE:
    case USER_PROFILE_GROUPS_REMOVE_FAILURE:
        return {
            ...state,
            User_profile_groups: {
                error: action.error,
                loading: false,
            },
        };

    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/reducers/user_profile.reducers.js